import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "nowports",
  interest_rate: 18,
  textos_tofu: {
    pm: {
      datos_accionista: {
        titulo: "Registro del accionista mayoritario y/o representante legal",
        sub_titulo:
          "En caso de tener más de un accionista en igualdad de acciones,\ningresar al que además funja como Representante Legal",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario y/o representante legal",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario y/o representante legal",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  cotizador: {
    current_currency: "USD",
    tasa_text: "+ SOFR",
    term_type: "días",
  },
  companyNames: ["Avenida Vessel SAPI de CV SOFOM", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario y/o Representante Legal de la empresa mencionada en esta solicitud.",
  firma: {
    provider: "mifiel",
    //"legalario",
    legalario_config: {
      custom_url_sdk:
        import.meta.env.VITE_ENV === "PROD"
          ? "https://sdk.legalario.com/3.0/sdk-dist.js"
          : "https://sdk.legalario.com/3.0/sdk-dev.js",
      organization_id: import.meta.env.VITE_ENV === "PROD" ? "651dec2d1f1e0d09a2532e64" : "651f490f1cd1fd5c2199c942",
      api_key:
        import.meta.env.VITE_ENV === "PROD"
          ? "9bcdd0595e6faf4c15caabce560ff7e8f0a9b56fbcf7e6374d372046fa3bcc40"
          : "9bcdd0595e6faf4c15caabce560ff7e8f0a9b56fbcf7e6374d372046fa3bcc40",
    },
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: true,
    },
    habilitar_comsion_apertura: true,
  },
  scripts: {
    tag_id_hotjar: "6487599",
    tag_id_google: "",
    tag_id_linkedin: "",
    tag_id_meta_pixel: "",
  },
  home_url: "",
  metadata: {
    title: "",
    description: "",
    favicon: "",
    keywords: undefined,
    ogImage: undefined,
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_sFjcqtCtk",
      userPoolClientId: "2pousl3im2gqghpte6eve21ti0",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_d5F4QKmWv",
      userPoolClientId: "6nbgtk3boancvo16cleok986nm",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
